
<template>
  <v-menu
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="options-button"
        transition="slide-x-transition"
        fab
        small
        plain
        depressed
        v-bind="attrs"
        v-on="on"
        @click="openOptions()"
      >
        <StIcon
          color="var(--ds-color-icon-2)"
          icon-name="dots-vertical"
        />
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="optionSelected(item)"
      >
        <v-list-item-title>
          {{ item }}
        </v-list-item-title>
      </v-list-item>
      <v-menu
        open-on-hover
        bottom
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-list-item
            v-bind="attrs"
            v-on="on"
          >
            <v-list-item-title>
              {{ exportLabel }} <DsIcon
                name="chevron-right"
                size="small"
                space="right"
              />
            </v-list-item-title>
          </v-list-item>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in exportExtensions"
            :key="`exportKey_${index}`"
            @click="exportSelectedComponent(item, $parent.$parent.$parent)"
          >
            <v-list-item-title>
              {{ item.type }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list>
  </v-menu>
</template>

<script>
import StIcon from '@stilingue/st-icon';
import exportModel from '@/mixins/export-model';
import { DsIcon } from '@ds/icons';

export default {
  name: 'CardOptions',
  components: {
    StIcon,
    DsIcon,
  },
  mixins: [
    exportModel,
  ],
  data() {
    return {
      optionsSelected: false,
    };
  },
  computed: {
    options() {
      return {
        RENAME: this.$t('components.models.CardOptions.label.rename'),
        DUPLICATE: this.$t('components.models.CardOptions.label.duplicate'),
        DELETE: this.$t('components.models.CardOptions.label.delete'),
      };
    },
    items() {
      return [
        this.options.RENAME,
        this.options.DUPLICATE,
        this.options.DELETE,
      ];
    },
  },
  methods: {
    openOptions() {
      this.optionsSelected = !this.optionsSelected;
    },
    optionSelected(value) {
      const optionsMap = {
        [this.options.RENAME]: 'rename',
        [this.options.DUPLICATE]: 'duplicate',
        [this.options.DELETE]: 'delete',
      };

      if (value in optionsMap) this.$emit(optionsMap[value]);
    },
  },
};
</script>

<style scoped lang="scss">
  .options-button {
    width: var(--ds-spacing-stack-md);
    height: var(--ds-spacing-stack-md);
    margin-left: var(--ds-spacing-inline-nano);
  }

  ::v-deep {
    .v-list {
      padding: var(--ds-spacing-inset-quark);
    }

    .v-list-item {
      min-width: 145px;
      height: 20px;
      border-radius: var(--ds-border-radius-sm);

      &:hover {
        cursor: pointer;
        background: var(--ds-color-background);
      }
    }
  }
</style>
